var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmarReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2622 24.75H18.7622M23.2622 33.75H18.7622M36.7622 15.75H18.7622M45.7622 15.3V38.7C45.7622 42.4804 45.7622 44.3705 45.0265 45.8144C44.3794 47.0845 43.3467 48.1171 42.0766 48.7643C40.6327 49.5 38.7426 49.5 34.9622 49.5H20.5622C16.7819 49.5 14.8917 49.5 13.4478 48.7643C12.1777 48.1171 11.1451 47.0845 10.4979 45.8144C9.76221 44.3705 9.76221 42.4804 9.76221 38.7V15.3C9.76221 11.5196 9.76221 9.62947 10.4979 8.18556C11.1451 6.91547 12.1777 5.88285 13.4478 5.23571C14.8917 4.5 16.7819 4.5 20.5622 4.5H34.9622C38.7426 4.5 40.6327 4.5 42.0766 5.23571C43.3467 5.88285 44.3794 6.91547 45.0265 8.18556C45.7622 9.62947 45.7622 11.5196 45.7622 15.3Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmarReports);
export default __webpack_public_path__ + "static/media/EmarReports.f923b33e8d25aa554c459c6aaf6ba198.svg";
export { ForwardRef as ReactComponent };